import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, FileTextIcon, ImageIcon, PrinterIcon, SparklesIcon } from 'lucide-react';
export function HeroSection() {
  const badges = [{
    icon: FileTextIcon,
    label: '+1.000 páginas'
  }, {
    icon: ImageIcon,
    label: 'Alta resolución'
  }, {
    icon: DownloadIcon,
    label: 'Descarga inmediata'
  }, {
    icon: PrinterIcon,
    label: 'Impresión de calidad'
  }];
  return <section className="relative py-12 md:py-20 px-4 bg-[#FFFAF7] overflow-hidden" data-id="element-45">
      {/* Soft pastel background accents */}
      <div className="pointer-events-none absolute -top-24 -left-24 w-72 h-72 rounded-full bg-[#FF6B8A]/10 blur-3xl" data-id="element-46" />
      <div className="pointer-events-none absolute -bottom-24 -right-24 w-80 h-80 rounded-full bg-[#9B8FE8]/10 blur-3xl" data-id="element-47" />

      <div className="relative max-w-7xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-48">
        {/* Mobile: Images on top / Desktop: Right column */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6
      }} className="w-full md:w-1/2 order-1 md:order-2 relative h-[400px] sm:h-[520px] md:h-[600px] flex items-center justify-center" data-id="element-49">
          <div className="absolute z-40 -top-2 right-2 md:right-6 bg-[#FFD166] text-[#2D2D3F] font-black px-4 py-2 rounded-full shadow-lg transform rotate-6 text-sm md:text-base border-2 border-white" data-id="element-50">
            ⭐ Más elegido
          </div>

          <img src="https://cdn.magicpatterns.com/uploads/ovxazyqe6TbNyon72GLS97/MEGA_PACK.png" alt="Mega Pack Disney Mockup" width="800" height="800" fetchPriority="high" decoding="async" loading="eager" className="w-full max-w-[620px] object-contain drop-shadow-[0_25px_45px_rgba(0,0,0,0.18)]" data-id="element-51" />
        </motion.div>

        {/* Mobile: Text below / Desktop: Left column */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} className="w-full md:w-1/2 order-2 md:order-1 flex flex-col space-y-8" data-id="element-52">
          {/* Premium eyebrow badge */}
          

          <div className="space-y-5" data-id="element-53">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-[#2D2D3F] leading-[1.05] tracking-tight" data-id="element-54">
              Mega Pack <br className="hidden sm:block" data-id="element-55" />
              <span className="relative inline-block" data-id="element-56">
                <span className="relative z-10" data-id="element-57">Disney</span>
                <span className="absolute inset-x-0 bottom-1 h-3 sm:h-4 bg-[#FFD166]/50 -z-0 rounded-sm" data-id="element-58" />
              </span>{' '}
              <span className="text-[#FF6B8A]" data-id="element-59">Coloring</span>
            </h1>

            <p className="text-base sm:text-lg text-[#6B7280] font-medium max-w-md leading-relaxed" data-id="element-60">
              10 libros de la colección en tendencia{' '}
              <span className="inline-block bg-[#9B8FE8]/15 text-[#5B4FB8] font-semibold px-2 py-0.5 rounded-md" data-id="element-61">
                Colorea y Descubre el Misterio
              </span>
              , con más de 100 páginas para colorear en cada uno.
            </p>
          </div>

          {/* Feature badges */}
          <ul className="grid grid-cols-2 gap-2.5 sm:gap-3 max-w-md" data-id="element-62">
            {badges.map(({
            icon: Icon,
            label
          }, index) => <li key={index} className="flex items-center gap-2 bg-white border border-gray-100 rounded-xl px-3 py-2.5 shadow-sm" data-id="element-63">
                <div className="bg-[#FFD166]/20 p-1.5 rounded-lg shrink-0" data-id="element-64">
                  <Icon className="w-4 h-4 text-[#FF6B8A]" data-id="element-65" />
                </div>
                <span className="text-xs sm:text-sm font-semibold text-[#2D2D3F] leading-tight" data-id="element-66">
                  {label}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}